<div class="ie-screen-block-container"
     *ngIf="(isBlocked$ | async) === true"
     [ngStyle]="{'display': 'block'}">
    <div class="ie-screen-block-overlay"></div>
    <div class="ie-screen-block-message-container">
        <!--
          We switch behavior by templateId:
          '' or 'none' -> just a spinner
          'message'    -> spinner + message
          'progress'   -> spinner + message + progress bar
        -->
        <div class="ie-screen-block-message"
             [ngStyle]="{'width': widthPx, 'margin-left': marginLeftPx}">
            <i class="fa fa-spinner fa-spin"></i>
            <div *ngIf="templateId === 'message' || templateId === 'progress'" class="col-xs-12 sp-0" style="margin-top: 10px;">
                {{ message }}
            </div>

            <!-- Progress bar (very minimal example) -->
            <div *ngIf="templateId === 'progress'"
                 class="col-xs-12 sp-0"
                 style="margin-top: 10px; border: 1px solid #FFF; height: 20px;">
                <div style="background-color: #999; height: 100%;"
                     [ngStyle]="{'width': progress + '%'}"></div>
            </div>
        </div>
    </div>
</div>
